const isValidBusinessCaseNumber = (businessCaseNumber) => {
	const fieldValueFirst = String(businessCaseNumber).slice(0, 15);
	const fieldValueLast = String(businessCaseNumber).slice(15);
	const reminderMod11 = Number(fieldValueFirst) % 11;
	const expectedLastNum = reminderMod11 === 10 ? 'A' : reminderMod11;
	// eslint-disable-next-line eqeqeq
	return fieldValueLast == expectedLastNum;
};

export default isValidBusinessCaseNumber;
